"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextMenuType = exports.ExtensionsEnum = exports.CatColorDisplayNewEnum = exports.CalendarTypeEnum = void 0;
var CalendarTypeEnum;
(function (CalendarTypeEnum) {
  CalendarTypeEnum["DEFAULT"] = "DEFAULT";
  CalendarTypeEnum["CUSTOM"] = "CUSTOM";
})(CalendarTypeEnum || (exports.CalendarTypeEnum = CalendarTypeEnum = {}));
var CatColorDisplayNewEnum;
(function (CatColorDisplayNewEnum) {
  CatColorDisplayNewEnum["NO_CATEGORY_COLOR"] = "NO_CATEGORY_COLOR";
  CatColorDisplayNewEnum["CATEGORY_COLOR_LINE"] = "CATEGORY_COLOR_LINE";
  CatColorDisplayNewEnum["CATEGORY_COLOR_BOOKING"] = "CATEGORY_COLOR_BOOKING";
})(CatColorDisplayNewEnum || (exports.CatColorDisplayNewEnum = CatColorDisplayNewEnum = {}));
var ExtensionsEnum;
(function (ExtensionsEnum) {
  ExtensionsEnum["APPROVAL"] = "approval";
  ExtensionsEnum["AUDIT_LOGS"] = "audit_log";
  ExtensionsEnum["CATEGORY_GROUPS"] = "category_groups";
  ExtensionsEnum["CUSTOM_COLUMNS"] = "custom_columns";
  ExtensionsEnum["CUSTOM_FIELDS"] = "cf";
  ExtensionsEnum["DEADLINES"] = "deadlines";
  ExtensionsEnum["DEPENDENCIES"] = "dependencies";
  ExtensionsEnum["EXTENDED_DASHBOARD"] = "extended_dashboard";
  ExtensionsEnum["FIXED_COSTS"] = "fixed_costs";
  ExtensionsEnum["HOLIDAY_CALENDARS"] = "holiday_calendars";
  ExtensionsEnum["MFA"] = "mfa";
  ExtensionsEnum["MY_DASHBOARD"] = "my_dashboard";
  ExtensionsEnum["PM"] = "pm";
  ExtensionsEnum["SIDEBAR_PRO"] = "sidebar_pro";
  ExtensionsEnum["SINGLE_SIGN_ON"] = "single_sign_on";
  ExtensionsEnum["RESOURCE_RATE"] = "rc";
  ExtensionsEnum["RESOURCE_REQUEST"] = "resource_request";
  ExtensionsEnum["SMART_FILTERS"] = "smart_filters";
  ExtensionsEnum["SMART_GROUPS"] = "smart_groups";
  ExtensionsEnum["SMART_SCHEDULES"] = "smart_schedules";
  ExtensionsEnum["TASKS"] = "tasks";
  ExtensionsEnum["TOIL"] = "toil";
  ExtensionsEnum["TIME_SHEET"] = "ts";
  ExtensionsEnum["UNASSIGNED"] = "unassigned";
  ExtensionsEnum["VACATION_REQUEST"] = "vacation_request";
  ExtensionsEnum["UNKNOWN"] = "UNKNOWN";
})(ExtensionsEnum || (exports.ExtensionsEnum = ExtensionsEnum = {}));
var ContextMenuType;
(function (ContextMenuType) {
  ContextMenuType["LEGACY"] = "LEGACY";
  ContextMenuType["NEW"] = "NEW";
})(ContextMenuType || (exports.ContextMenuType = ContextMenuType = {}));